import { GroupShort } from 'src/@types/modules/groups/groups.types'
import { baseApi } from 'src/api/baseApi'

const api = baseApi.injectEndpoints({
        endpoints: builder => ({
            getTeacherGroups: builder.query<GroupShort[], { params: { branchId: number, teacherId: number } }>({
                providesTags: (_res, _err, { params }) => [{
                    type: 'BranchTeacherGroups',
                    id: `${params.branchId}-${params.teacherId}`,
                }],
                query: ({ params }) => ({
                    url: `/branches/${params.branchId}/teachers/${params.teacherId}/groups`,
                    method: 'GET',
                    errorMessage: () => {
                        return 'Не удалось получить информацию о группах!'
                    },
                }),
            }),
            getTeacherSubjects: builder.query<GroupShort[], {
                params: { branchId: number, teacherId: number },
                search: { groupId?: number },
            }>({
                providesTags: (result?: GroupShort[]) =>
                    result
                    ? [...result.map((group: GroupShort) => ({ type: 'Group' as const, id: group.id }))]
                    : ['Group'],
                query: ({ params, search }) => ({
                    url: `/branches/${params.branchId}/teachers/${params.teacherId}/subjects`,
                    params: { groupId: search.groupId },
                    method: 'GET',
                    errorMessage: 'Не удалось получить информацию о группах!',
                }),
            }),
        }),
    },
)

export const {
    useGetTeacherGroupsQuery,
    useGetTeacherSubjectsQuery,
} = api
